import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

export enum ArrayType {
    String,
    Number
}

@Injectable()
export class ConfigService {
    private http: HttpClient;
    private envJson: any;
    private validConfig: boolean;

    constructor(private injector: Injector) {
        this.validConfig = false;
    }

    load(): any {
        if (environment.jsonConfig) {
            this.http = this.injector.get(HttpClient);
            const headers: HttpHeaders = new HttpHeaders({ 'Cache-Control': 'no-cache', 'Pramga': 'no-cache', 'no-auth': 'true' });
            return this.http.get(environment.jsonConfig, { headers: headers })
                .toPromise()
                .then((result: any) => {
                    this.envJson = result;
                    this.validConfig = true;
                    return result;
                })
                .catch((error: any) => {
                    return error;
                });
        } else {
            this.validConfig = true;
        }
    }

    isValidConfig(): boolean {
        return this.validConfig;
    }

    getEnv(key: any): any {
        let val: any;
        if (this.envJson) {
            val = this.envJson[key] !== undefined ? this.envJson[key] : environment[key];
        } else {
            val = environment[key];
        }
        if (!isNaN(val)) {
            val % 1 === 0 ? parseInt(val, 10) : parseFloat(val);
        }
        return val;
    }

    getArray(key: any, type: ArrayType): any {
        let val: string;
        if (this.envJson) {
            val = this.envJson[key] !== undefined ? this.envJson[key] : environment[key];
        } else {
            val = environment[key];
        }
        const separator: string = val[0];
        const vals: string[] = val.split(separator);
        vals.shift();
        return vals.map((item: string) => {
            let typedItem: number | string;
            switch (type) {
                case ArrayType.Number:
                    typedItem = parseInt(item, 10);
                    break;
                default:
                    typedItem = item;
                    break;
            }
            return typedItem;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/config.service.ts